import { DragDropGroup } from 'src/app/shared/components/sb-drag-drop-list/drag-drop.interface';

export const REPORT_CONTENT_CONFIG: Array<DragDropGroup> = [
    {
        id: 'portfolio-value-over-time',
        name: 'Value over time',
        description: 'Performance or market value changes over the selected period',
        disabled: false,
        icon: 'chart-bar',
        subgroups: [
            {
                id: 'portfolio-value-over-time-key-metrics',
                name: 'Key metrics',
                description: 'Performance metrics for the selected period',
                disabled: false,
                icon: 'chart-bar',
                order: 2
            },
            {
                id: 'portfolio-value-over-time-chart',
                name: 'Performance chart',
                description:
                    'Chart of your portfolio performance over the selected period',
                disabled: false,
                icon: 'chart-histogram',
                order: 3
            }
        ],
        order: 1
    },
    {
        id: 'portfolio-trades',
        name: 'Trades during period',
        description:
            'List of trades during the selected period. Note: trades will not be included in the report if no trades are found.',
        disabled: false,
        icon: 'list',
        order: 4
    },
    {
        id: 'portfolio-dividends',
        name: 'Dividends during period',
        description:
            'List of dividends during the selected period. Note: dividends will not be included in the report if no dividends are found.',
        disabled: false,
        icon: 'list',
        order: 5
    },
    {
        id: 'portfolio-allocations',
        name: 'Portfolio allocations',
        description: 'Show allocation and how it has changed during the selected period',
        disabled: false,
        icon: 'chart-pie',
        order: 6
    },
    {
        id: 'portfolio-asset-performance',
        name: 'Holdings list',
        description: 'Detailed breakdown of all holdings',
        disabled: false,
        icon: 'list',
        order: 7
    },
    {
        id: 'group-period-summary',
        name: 'Period performance summary',
        description: 'Summary of your portfolio performance over the selected period',
        disabled: false,
        icon: 'list',
        order: 8
    }
];

export type ReportContentConfig = {
    [key: string]: {
        id: string;
        name: string;
        description: string;
        include: boolean;
        order: number;
        icon: string;
        subgroups: {
            [key: string]: {
                id: string;
                name: string;
                description: string;
                include: boolean;
                order: number;
                icon: string;
            };
        };
    };
};

export const reportContentConfigToDragDropGroup = (
    config: ReportContentConfig
): Array<DragDropGroup> => {
    return Object.values({ ...config }).map((item) => {
        return {
            id: item.id,
            name: item.name,
            description: item.description,
            disabled: !item.include,
            icon: item.icon,
            order: item.order,
            subgroups: Object.values(item.subgroups).map((subgroup) => ({
                ...subgroup,
                order: subgroup.order,
                subgroups: []
            }))
        };
    });
};

export const dragDropGroupToReportContentConfig = (
    config: Array<DragDropGroup>
): ReportContentConfig => {
    const copy = [...config];
    const result = copy.reduce(
        (acc, item) => ({
            ...acc,
            [item.id]: {
                id: item.id,
                name: item.name,
                description: item.description,
                include: !item.disabled,
                icon: item.icon,
                order: item.order,
                subgroups:
                    item.subgroups?.reduce(
                        (acc, subgroup) => ({
                            ...acc,
                            [subgroup.id]: subgroup
                        }),
                        {}
                    ) || {}
            }
        }),
        {} as ReportContentConfig
    );
    return result;
};
export const DEFAULT_REPORT_CONTENT_CONFIG: ReportContentConfig =
    dragDropGroupToReportContentConfig(REPORT_CONTENT_CONFIG);
